import { SunfishNestApi } from './../../shared/nestjs/gd-only/services/sunfish.api';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { SunfishApi } from './../../shared/sdk/services/custom/Sunfish';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';


@Injectable()
export class OrganizationStructureBloc {

	private subscriptions: Array<Subscription> = [];

	constructor(
		private sunfishApi: SunfishApi,
		private nestApiProvider: NestApiProvider,
		private sunfishNestApi: SunfishNestApi
	) { }

	public dispose() {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	getOrgStruct(empId) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.apiGetOrgStruct(empId).subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error)
				})
			)
		})
	}

	private apiGetOrgStruct(param): Observable<any> {
		return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
			.mergeMap(isGoPathNewExist => {
				if (isGoPathNewExist) {
					return this.sunfishNestApi.getOrgStruct(param)
						.pipe(
							map(data => data.data)
						)
				} else {
					return this.sunfishApi.getOrgStruct({ empId: param });
				}
			})
	}
}


// WEBPACK FOOTER //
// ./src/bloc/company/organization-structure.bloc.ts